module["exports"] = [];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/name/suffix.js
 ** module id = 916
 ** module chunks = 0
 **/